export const DONATION_AMOUNTS_TO_SHOW = [
  "zero",
  "two",
  "five",
  "ten",
  "twentyfive",
] as const;

export type DonationAmountType = (typeof DONATION_AMOUNTS_TO_SHOW)[number];
